<template>
  <div>
    <div class="menu" id="menu">
      <div class="content1">
        <!-- <div class="logo">
          <router-link to="/">千种药用植物基因组数据库</router-link>
        </div> -->
        <div class="btn">
          <!-- <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" class="black"><router-link to="/">Home</router-link></el-menu-item>
            <span></span>
            <el-menu-item index="3"><router-link to="/blastcenter">Blast</router-link></el-menu-item>
             <el-menu-item index="4">|</el-menu-item>
            <el-menu-item index="5"><router-link to="/primer">Primer design</router-link> </el-menu-item>
            <el-menu-item index="3"><router-link to="/download">Download</router-link></el-menu-item>
          </el-menu> -->
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/blastcenter">Blast</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="contenter">
      <div class="title">
        <span class="el-icon-document"></span>
        <span>News & Updates</span>
      </div>
      <h1 class="newsTitle">雷公藤基因组及其活性成分雷公藤甲素生物合成</h1>
      <div class="des">
        本研究通过构建一个高质量的雷公藤基因组，发现雷公藤生物合成途径基因受到最近的全基因组复制事件的影响。结合基因组、转录组和代谢组的多组学研究揭示雷公藤甲素代谢途径，成功筛选并鉴定细胞色素P450（CYP728B70）基因，其编码蛋白催化三步氧化反应生成雷公藤甲素中间体Dehydroabietic
        acid，进而通过合成生物学策略实现其在酿酒酵母中的异源合成。这项工作有助于雷公藤甲素生物合成途径的揭示，为雷公藤甲素的生物合成奠定基础。
      </div>
      <div class="img">
        <img src="../../assets/news1_1.png" width="60%" />
      </div>
      <div class="des1">
        <strong>标题：</strong>Genome of Tripterygium wilfordii and
        identification of cytochrome P450 involved in triptolide biosynthesis<br />
        <strong>研究团队：</strong
        >首都医科大学高伟教授团队、中国中医科学院黄璐琦院士团队<br />
        <strong>期刊：</strong>Nature communications (IF:11.878)<br />
        <strong>研究背景：</strong><br />
        <div class="textindent">
          雷公藤（Tripterygium
          wilfordii）是治疗类风湿性关节炎等疾病的传统中药。其主要活性成分雷公藤甲素（Triptolide）具有抗炎、免疫抑制、抗肿瘤活性，特别是对胰腺癌细胞。但是雷公藤植物栽培周期长，雷公藤甲素的植物提取产率极低，化学合成困难，价格昂贵，雷公藤植物资源面临巨大挑战。雷公藤基因组序列的破译和雷公藤甲素生物合成途径的揭示将有助于雷公藤甲素生物合成研究的推进，是解决雷公藤甲素资源获取的前提条件。
        </div>
        <strong>主要研究内容：</strong><br />
        1.基因组组装及注释<br />
        <div class="textindent">
          结合PacBio、10X Genomics及Hi-C进行测序组装，获得348.38
          Mb的基因组，Contig N50为4.36Mb，Scaffold
          N50为13.52Mb；共注释28321个蛋白编码基因，重复序列为52.36%。
        </div>
        <div class="img">
          <img src="../../assets/news1_2.png" width="60%" />
        </div>
        <div class="des1">
          2.基因组进化促进了雷公藤甲素的形成<br />
          <div class="textindent">
            使用15种植物的514个单拷贝基因进行进化树构建和分化时间估计，研究发现雷公藤与木薯、毛果杨的祖先关系最近，估计分化时间为87.10MYA。基因家族聚类显示，雷公藤拥有951个特有基因家族，KO和KEGG注释发现，其在萜烯合酶、氧化还原过程和植物-病原相互作用等功能上富集。4DTv分布及共线性分析显示，雷公藤经历了核心双子叶植物γ三倍化事件，同时在与毛果杨和木薯发生分化后，又经历了另一个特有的全基因组复制事件。雷公藤最近的WGT事件发生在古第三纪（65-23.3mya）到新第三纪（23.3-1.64mya）期间，全基因组复制可能使其通过功能冗余、突变、提高进化率和适应性等，更好地应对环境的变化。雷公藤甲素生物合成途径基因的拷贝数受全基因组复制事件的影响，表明该过程对雷公藤甲素合成至关重要。同时，在雷公藤基因组中还发现TwCPS1、TwMS基因簇。
          </div>
        </div>
        <div class="img">
          <img src="../../assets/news1_3.png" width="60%" />
        </div>
        <div class="des1">
          3.特异性CYP基因的鉴定及功能验证<br />
          <div class="textindent">
            通过基因组、转录组和代谢组学数据，作者绘制了从基因到代谢物网络的图谱，结合可诱导性和组织特异性分析，最终筛选出与雷公藤甲素生物合成有关的10种细胞色素酶CYP基因。借助遗传转化系统及合成生物学工具，成功筛选并鉴定细胞色素P450（CYP728B70）基因，结果显示CYP728B70的低转录水平限制了产物的合成。该基因是CYP728家族第一个被明确功能的基因，其编码蛋白催化三步氧化反应生成雷公藤甲素中间体Dehydroabietic
            acid，进而通过合成生物学策略实现其在酿酒酵母中的异源合成。该研究还提供了参与雷公藤甲素生物合成的候选P450基因、代谢物及调控雷公藤甲素生物合成的转录因子，为推进雷公藤甲素生物合成途径的完全解析奠定了重要基础。
          </div>
        </div>
        <div class="img1">
            <div>
               <img src="../../assets/news1_4.png" width="30%" />
               <img src="../../assets/news1_5.png" width="30%" />
            </div>
        </div>
         <div class="des1">
            <strong>研究意义：</strong><br />
            <div class="textindent">
              本研究为雷公藤及其它植物药用资源保护和持续利用提供新的研究策略和有效途径，也为植物细胞色素P450家族功能研究提供借鉴，对于发掘保护我国重要药用植物基因资源、揭示中药活性成分形成分子机制、指导遗传育种及其有效成分“细胞工厂”合成生物学生产等具有重要科学意义和巨大应用价值。
            </div>
         </div>
      </div>
    </div>
  </div>
</template>
<script>
import Species from "../page/Species.vue";
export default {
  components: { Species },
  created(){
    window.addEventListener("scroll", this.handleScroll);
  },
  methods:{
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector("#menu").offsetTop;
      let isFixed = scrollTop > offsetTop ? true : false;
      if (isFixed) {
        document.querySelector("#menu").style =
          "position: fixed;top:0;background:#fff;z-index:9999";
      } else {
        document.querySelector("#menu").style = "";
      }
    },
  }
};
</script>
<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.contenter {
  width: 1140px;
  margin: 0 auto;
  /* height: 500px; */
  box-shadow: 0 0 10px #bbb;
  padding: 0 30px;
  background: #fff;
  min-height: 500px;
}
.contenter .newsTitle {
  text-align: center;
  line-height: 30px;
  font-size: 16px;
}
.contenter .time {
  text-align: center;
  margin-left: 200px;
  font-size: 12px;
  color: #444;
}
.contenter .title {
  height: 70px;
  width: 100%;
  /* border: 1px solid red; */
  line-height: 70px;
  font-size: 16px;
  font-weight: bold;
}
.contenter .title .el-icon-document {
  margin-right: 10px;
  font-size: 20px;
  /* line-height: 30px; */
  color: seagreen;
  font-weight: bold;
}
.contenter .des {
  background: #eef6f0;
  color: #555;
  line-height: 25px;
  padding: 15px 20px;
  font-size: 14px;
  text-indent: 30px;
}
.contenter .des1 {
  /* background: #eef6f0; */
  color: #555;
  line-height: 30px;
  padding: 15px 20px;
  font-size: 14px;
}
.contenter .textindent {
  text-indent: 30px;
}
.contenter .img {
  width: 100%;
  text-align: center;
}
.contenter .img1 {
  width: 100%;
  text-align: center;
  overflow: auto;
}
.contenter .img1 div{
  width: 60%;
  margin: 0 auto;
}
.contenter .img1 img{
  float: left;
  width: 50%;
}
.contenter .img {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  line-height: 25px;
  overflow: auto;
  padding-bottom: 30px;
}
</style>
